module.exports = __webpack_public_path__ + "assets/img/1-2.58e8a461.png";